import { JSX } from 'react';
import {
    List,
    TextField,
    TopToolbar,
    CreateButton,
    FilterButton,
    ExportButton,
    Datagrid,
    EditButton,
    SelectField,
    SearchInput,
    TextInput,
    SelectInput
} from 'react-admin';
import { enterpriseRequestStatus } from "../../defaults/defaults";

const ListActions: () => JSX.Element = (): JSX.Element => {
    return(
        <TopToolbar>
            {/* No gate here on purpose: react-admin asks `authProvider.canAccess` for this button
                itself, and the map there names the verb. A check beside it would be the same
                rule written twice. */}
                <CreateButton />
            <FilterButton />
            <ExportButton />
        </TopToolbar>
    );
}

const requestFilter: JSX.Element[] = [
    <SearchInput source="name" alwaysOn />,
    <TextInput label="email" source="email" />,
    <SelectInput label="Status" source="status" choices={ enterpriseRequestStatus } />
];

export const EnterpriseRequestsList: () => JSX.Element = (): JSX.Element => {

    return (
        <List
            actions={<ListActions/>}
            filters={ requestFilter }
            sort={{ field: 'id', order: 'DESC' }}
        >
            <Datagrid bulkActionButtons={false} >
                <TextField source="id" />
                <TextField source="name"  />
                <TextField source="email"  />
                <SelectField source="status" choices={ enterpriseRequestStatus } />
                <EditButton />
            </Datagrid>
        </List>
    );
}
